<ng-container *ngIf="state$ | async as state">
    <div
        *ngIf="state.status === 'update_available' && !dismissed"
        class="app-update-bar"
        role="status"
    >
        <i class="pi pi-refresh"></i>
        <span class="app-update-bar__text">
            Hay una versión nueva del sistema{{ state.latestVersion ? ' (' + state.latestVersion + ')' : '' }}.
            {{ state.notes }}
        </span>
        <button
            pButton
            type="button"
            label="Actualizar"
            class="p-button-sm"
            [loading]="reloading"
            (click)="reload()"
        ></button>
        <button
            pButton
            type="button"
            icon="pi pi-times"
            class="p-button-sm p-button-text p-button-plain"
            aria-label="Cerrar aviso"
            (click)="dismissed = true"
        ></button>
    </div>

    <p-dialog
        [visible]="state.status === 'update_required' && !bypassed"
        [modal]="true"
        [closable]="false"
        [draggable]="false"
        [resizable]="false"
        [style]="{ width: '28rem', maxWidth: '92vw' }"
        header="Actualización necesaria"
    >
        <p class="m-0">
            Esta versión del sistema ({{ state.currentVersion }}) ya no es compatible. Recarga para usar la
            versión {{ state.latestVersion }}; tu sesión se conserva.
        </p>
        <p *ngIf="state.notes" class="mt-3 mb-0">{{ state.notes }}</p>
        <p *ngIf="canBypass" class="mt-3 mb-0 text-sm text-color-secondary">
            Si esta versión todavía no está desplegada, corrígelo desde Versiones de la app.
        </p>
        <ng-template pTemplate="footer">
            <button
                *ngIf="canBypass"
                pButton
                type="button"
                label="Ir a Versiones de la app"
                icon="pi pi-cog"
                class="p-button-text"
                (click)="goToReleases()"
            ></button>
            <button
                pButton
                type="button"
                label="Actualizar ahora"
                icon="pi pi-refresh"
                [loading]="reloading"
                (click)="reload()"
            ></button>
        </ng-template>
    </p-dialog>
</ng-container>
